import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { paymentsFetch } from "./paymentsFetch";
import { useNavigate } from "react-router-dom";

const updatePaymentScheduleOperator = async (data: { paymentSchedule: any[] }, bookingId: string) => {
  return paymentsFetch(`/api/payment-schedule-step/${bookingId}/operator`, "PATCH", data.paymentSchedule);
};

export const useUpdatePaymentScheduleOperator = (bookingId: string) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { paymentSchedule: any[]; toastId: any }) => updatePaymentScheduleOperator(data, bookingId),
    onSuccess: (_, variables) => {
      console.log("variables", variables);
      dismiss(variables.toastId);
      toast({
        title: "Success",
        description: "Payment schedule updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["paymentScheduleOperatorData", bookingId] });

      navigate(`/bookings/${bookingId}?tab=payments`, { replace: true });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Something went wrong!",
        variant: "destructive",
      });
    },
  });
};
